(function (angular) {
	'use strict';

	angular
		.module('twoFactorAuthModule')
		.controller('TwoFactorLogin', [
			'$timeout',
			'urlFactory',
			'APP_BASE_PATH',
			TwoFactorLoginFunction
		]);

	function TwoFactorLoginFunction(
		$timeout, 
		urlFactory,
		APP_BASE_PATH
	) {
		var twoFactorLogin = this;

		twoFactorLogin.resendCode = function() {
			urlFactory.postPromise('/login-verify/resendcode');
		};

		twoFactorLogin.$onInit = function() {
			
			twoFactorLogin.lostDeviceFaqUrl = APP_BASE_PATH + '/education/faq#item601';
			
			if(urlFactory.getUrlParamAsBool('loginFailed')) {
				$timeout(function() {
					var loginErrorObject = {
						authCode: 'Security code is incorrect. Please try again.'
					};
					
					urlFactory.handleServerValidation(twoFactorLogin.twoFactorAuthForm, urlFactory.spoofApiError(loginErrorObject));
				}, 100);
			}
			twoFactorLogin.attempts = urlFactory.getUrlParamAsNumber('attemptsLeft');
		};
	}
})(window.angular);